import { FunctionComponent, ReactNode } from 'react'

export type BadgeTone =
  | 'success'
  | 'warning'
  | 'danger'
  | 'neutral'
  | 'info'
  | 'primary'

const StatusBadge: FunctionComponent<{
  tone: BadgeTone
  children: ReactNode
}> = ({ tone, children }) => (
  <span className={`status-badge status-badge-${tone}`}>{children}</span>
)

export default StatusBadge
